import { render } from "./KOLs.vue?vue&type=template&id=0ec0de36"
import script from "./KOLs.vue?vue&type=script&lang=js"
export * from "./KOLs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__